// Helpers de mês de referência e código de UC usados pelo Rateio.
//
// A normalização de mês e o ordinal vêm de `_shared/consumoObservado.ts`, que é
// a mesma fonte usada pela rotina diária que grava `consumo_observado_kwh`. Se
// o front normalizasse mês de um jeito e a rotina de outro, os dois chegariam a
// médias diferentes para a mesma UC — e esse número aloca energia. Mesmo padrão
// de `src/lib/splitParceira.ts`.
//
// ⚠️ NÃO confundir com `src/lib/mesReferencia.ts`, que é outro módulo (usado por
// Financeiro e Dashboard, com `normalizeMesReferencia`/`isMesReferenciaCanonico`).
//
// `limparUc` continua local: é a réplica de FinanceiroLayout.cleanUC, e o módulo
// de rateio não importa de `views/Financeiro/` (convenção já estabelecida).

export {
  MESES_ORDEM,
  normalizarMesReferencia,
  mesReferenciaParaOrdinal,
  rotuloDeOrdinal,
} from '../../../supabase/functions/_shared/consumoObservado.ts';

import { MESES_ORDEM } from '../../../supabase/functions/_shared/consumoObservado.ts';

/** Réplica local de FinanceiroLayout.cleanUC. */
export function limparUc(uc: unknown): string {
  if (typeof uc !== 'string' && typeof uc !== 'number') return '';
  return String(uc).replace(/[.\-\s]/g, '').replace(/^0+/, '');
}

/**
 * Gera os `n` últimos meses no formato "MES/ANO", do mais antigo pro mais
 * recente, terminando no mês de `referencia` (default: hoje). Aritmética pura
 * (sem Intl/ICU) — evita ambiguidade de formatação locale-dependente.
 */
export function gerarUltimosMeses(n: number, referencia: Date = new Date()): string[] {
  const ordinalAtual = referencia.getFullYear() * 12 + referencia.getMonth();
  const labels: string[] = [];
  for (let i = n - 1; i >= 0; i--) {
    const ordinal = ordinalAtual - i;
    const ano = Math.floor(ordinal / 12);
    const mesIdx = ((ordinal % 12) + 12) % 12;
    labels.push(`${MESES_ORDEM[mesIdx]}/${ano}`);
  }
  return labels;
}
